import * as React from 'react';
import classNames from 'classnames';
import './Radio.scss';

export interface IRadioProps extends React.HTMLProps<HTMLInputElement> {
  children?: any;
}

const Radio = ({ children, className, ...props }: IRadioProps) => {
  return (
    <label className={classNames('Radio', className)}>
      <input type="radio" className="Radio-Input" {...props} />
      <span className="Radio-Box" />
      {children && (
        <span className="Radio-Label ml-2">{children}</span>
      )}
    </label>
  );
}

export default Radio;



// WEBPACK FOOTER //
// ./src/components/FormElements/Radio.tsx